module.exports = __webpack_public_path__ + "assets/img/prize_5.55aa85a9.png";